import { getServiceInitials } from 'src/common/util'
import * as Styles from '../styles'
import { Badge, Image } from 'antd';
import { ContractDetail } from 'src/common/models/contract'

interface Props {
    itemDetail: ContractDetail
}

export const ItemData = (props: Props) => {
    const renderServiceImage = () => (
        <Image
            style={{ position: 'relative', borderRadius: 8, }}
            width={'100%'}
            src={props.itemDetail.imageUrl}
            preview={false}
        />
    )

    const renderRibbon = () => {
        return <Badge dot={true} color='blue'>
            {renderItemImage()}
        </Badge>
    }

    const renderItemImage = () => (
        <Styles.ImageContainer>
            <Styles.ItemImageContainer>
                {
                    props.itemDetail.imageUrl && props.itemDetail.imageUrl.trim().length > 0
                        ? renderServiceImage()
                        : getServiceInitials(props.itemDetail.serviceName)
                }
            </Styles.ItemImageContainer>
        </Styles.ImageContainer>
    )

    const renderDescriptionSection = () => (
        <Styles.DescriptionContainer>
            <Styles.ItemId>{props?.itemDetail.serviceCategoryName}</Styles.ItemId>
            <Styles.ItemId>{props?.itemDetail?.externalId || props?.itemDetail?.serviceId}</Styles.ItemId>
            <Styles.ItemDescription>{props.itemDetail?.serviceName} </Styles.ItemDescription>
        </Styles.DescriptionContainer>
    )

    return (
        <Styles.TopContainer>
            {!props.itemDetail.isMonthly
                ? renderItemImage()
                : renderRibbon()}
            {renderDescriptionSection()}
        </Styles.TopContainer>
    )
}
